import axiosClient from '../axiosClient';

const templateService = {
  async getTemplates(params = {}) {
    try {
      const response = await axiosClient.get('/template', { params });
      return response.data.data.templates;
    } catch (error) {
      return Promise.reject(error?.response?.data?.message || "errors.failed_to_fetch_data");
    }
  },

  async copyTemplate(templateId) {
    try {
      const response = await axiosClient.post(`/template/${templateId}`);
      return response.data;
    } catch (error) {
      return Promise.reject(error?.response?.data?.message || "errors.failed_to_copy_template");
    }
  },
  
  async deleteTemplate(templateId) {
    try {
      const response = await axiosClient.delete(`/template/${templateId}`);
      return response.data;
    } catch (error) {
      return Promise.reject(error?.response?.data?.message || "errors.failed_to_delete_template");
    }
  },
};

export default templateService;
